import { render, staticRenderFns } from "./WorkRelativityViz.vue?vue&type=template&id=4c5f139f&scoped=true"
import script from "./WorkRelativityViz.vue?vue&type=script&lang=js"
export * from "./WorkRelativityViz.vue?vue&type=script&lang=js"
import style0 from "./WorkRelativityViz.vue?vue&type=style&index=0&id=4c5f139f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5f139f",
  null
  
)

export default component.exports